export enum AppModule {
  dashboard = "dashboard",
  chat = "chat",
  people = "people",
  tasks = "tasks",
  drive = "drive",
  calls = "calls",
  travelLog = "travelLog",
  clients = "clients",
  integrations = "integrations",
  waAutomation = "waAutomation",
  orderForms = "orderForms",
  workspace = "workspace",
  inventory = "inventory",
  invoices = "invoices",
  clientSupport = "clientSupport",
}
